import React from "react";
import { RecommendedProductCardProps } from "../../types/search";
import {
  isProductResult,
  convertToRecommendedProduct,
} from "../../search-core/recommendations/converters";
import "../../styles.css";

/**
 * RecommendedProductCard - Displays a product card in the recommendations section
 *
 * This component shows a product image, name, price, and an action button.
 * No functionality except optional click handlers for future use.
 */
const RecommendedProductCard: React.FC<RecommendedProductCardProps> = ({
  product,
  onActionClick,
}) => {
  // Ensure we have a RecommendedProduct (convert if necessary)
  const uiProduct = isProductResult(product)
    ? convertToRecommendedProduct(product)
    : product;
  console.log(uiProduct);

  // Extract availability and old price
  const available = uiProduct.available;
  const oldPrice = uiProduct.oldPrice;
  const handleActionClick = () => {
    // Optional callback for future use
    if (onActionClick) {
      onActionClick(uiProduct.id);
    }
  };

  // Format price for display
  const formatPrice = (price: number | string): string => {
    if (typeof price === 'number') {
      // Format number with spaces as thousands separators and add currency symbol
      return price.toLocaleString('ru-RU') + ' ₽';
    }
    return String(price);
  };


  return (
    <div className="recommended-product-card">
      <div className="product-image">
        <img
          src={uiProduct.imageUrl}
          alt={uiProduct.name}
          className="image"
          onError={(e) => {
            const img = e.currentTarget;
            img.onerror = null; // 🔴 критично — рвём цикл
            img.src = "/images/no-image.svg";
          }}
        />
      </div>
      <div className="product-info">
        <div className="product-name">{uiProduct.name}</div>
        <div className="">
          <div className="flex justify-between items-center">
            <div className="flex items-center justify-between gap-2">
              <p className="product-price">{uiProduct.price}</p>
              {oldPrice !== undefined && oldPrice !== null && (
                <p className="old-price">{formatPrice(oldPrice)}</p>
              )}
            </div>
            <button
              type="button"
              className="product-action-button"
              onClick={handleActionClick}
              disabled={available === false}
              aria-label={`${uiProduct.actionLabel || "В корзину"} ${
                uiProduct.name
              }`}
            >
              <img src="/src/img/shopping-cart.svg" />
            </button>
          </div>
          {available !== undefined && (
            <p className={available ? 'text-success-status' : 'text-critical-status'}>
              {available ? 'В наличии' : 'Нет в наличии'}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecommendedProductCard;
